function filterParams(options) {
  const params = {}
  for (const key in options) {
    const value = options[key]
    if (value) {
      params[key] = value
    }
  }
  return params
}

export default (axios) => ({
  async getGames(reqOptions) {
    const url = '/games/'
    const options = {
      // title: reqOptions.title,
      // platform: reqOptions.platform
    }
    const params = filterParams(options)
    return (await axios.get(url, { params })).data.data
  },
  async getGameById(id) {
    const url = `/games/${id}`
    return (await axios.get(url)).data.data
  }
})



// WEBPACK FOOTER //
// ./src/pkg/api/games.js